import type { BasicResultFieldKey } from '../../../medilab/latest/fields'
import type {
  ReportableMedKey,
  ReportableRpKey,
} from '../../../medilab/latest/detail/useReportField'

/** 旗を立てる先。顧客側 useReportField の Report と同じ形（行と 1:1） */
export type ReportTarget =
  | { scope: 'basic'; key: BasicResultFieldKey }
  | { scope: 'rp'; rpIndex: number; key: ReportableRpKey }
  | { scope: 'med'; rpIndex: number; medIndex: number; key: ReportableMedKey }

/**
 * 行 → OCRError.label。**店の 4 view と同じ規則**（prescription/views.py の
 * BasicResultReportView / RPUnitReportView / MedicationReportView）:
 *
 * - basic → `key`（依頼系「複数患者分割」等も key のまま）
 * - RP 単位 → `rp_{rpIndex+1}_{key}`（医薬品漏れは RP1 に書くので `rp_1_医薬品取得`）
 * - 薬剤行 → `rp_{rpIndex+1}_{medIndex+1}_{key}`
 *
 * 同じ欄に店が立てた旗と annotator が立てた旗が同じ label になり、夜の集計で同じ欄として数えられる。
 */
export const reportLabel = (target: ReportTarget): string => {
  switch (target.scope) {
    case 'basic':
      return target.key
    case 'rp':
      return `rp_${target.rpIndex + 1}_${target.key}`
    case 'med':
      return `rp_${target.rpIndex + 1}_${target.medIndex + 1}_${target.key}`
  }
}
